import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.sass'],
    standalone: false
})

export class BreadcrumbComponent {

  @Input() items: string[] = [''];
  
}